/**
 * Admin user management API
 */
import { apiClient } from './client';
import type { AdminUser, AdminUserUpdate, PasswordResetResponse } from '../types/admin-users';

export const adminUsersApi = {
  /**
   * List all users, optionally filtered by tenant
   */
  list: async (tenantId?: string): Promise<AdminUser[]> => {
    const params = tenantId ? `?tenant_id=${tenantId}` : '';
    const response = await apiClient.get(`/api/admin/users${params}`);
    return response.data;
  },

  /**
   * Get a specific user by ID
   */
  get: async (userId: string): Promise<AdminUser> => {
    const response = await apiClient.get(`/api/admin/users/${userId}`);
    return response.data;
  },

  /**
   * Update user enabled status
   */
  update: async (userId: string, data: AdminUserUpdate): Promise<AdminUser> => {
    const response = await apiClient.put(`/api/admin/users/${userId}`, data);
    return response.data;
  },

  /**
   * Trigger password reset for a user
   */
  resetPassword: async (userId: string): Promise<PasswordResetResponse> => {
    const response = await apiClient.post(`/api/admin/users/${userId}/reset-password`);
    return response.data;
  },
};
